/* eslint-disable max-params */
/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from 'lib/widgets/Button/Button';

const images = require.context('themes/ocado/assets/images/icons/ysh', false, /\.(svg)$/);

class CardItemsSavingMoney extends PureComponent {
  static propTypes = {
    cardContent: PropTypes.object.isRequired,
    buttonLink: PropTypes.string.isRequired,
    smartPassType: PropTypes.string.isRequired,
    rightArrowIcon: PropTypes.string.isRequired,
    whiteCopy: PropTypes.string,
  };

  copyToClipboard = () => {
    const textElement = document.querySelector('.voucher-text');
    if (textElement) {
      const text = textElement.textContent;
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        // Handle error silently
      }
      document.body.removeChild(textArea);
    }
  };

  renderHeader = (cardContent) => (
    <div className="card-content__header">
      <img src={images(`./${cardContent.icon}`)} alt={`${cardContent.text} Icon`} />
      <span>{cardContent.text}</span>
    </div>
  );

  renderDetails = (cardContent, smartPassType) => {
    const hasCoupons = cardContent.couponsToUse !== null && cardContent.couponsToUse !== undefined;
    return (smartPassType || hasCoupons) && (
      <div className="card-content__details">
        <div className="card-content__details-data">
          {hasCoupons && <p>{cardContent.couponsToUse}</p>}
          {smartPassType && <h3>{cardContent.title} {'Pass'} </h3>}
        </div>
        {hasCoupons && <h3>{cardContent.title}</h3>}
      </div>
    );
  };

  renderActions = (cardContent, whiteCopyPath, rightArrowIconPath, isCopyButton, buttonLink) => (
    <div className="card-content__actions">
      {cardContent.pricePromiseVoucher && <p className="voucher-text">{cardContent.pricePromiseVoucher}</p>}
      <Button
        primary
        className={`card-content__button ${isCopyButton ? 'no-left-radius' : ''}`}
        onClick={isCopyButton ? this.copyToClipboard : undefined}
        to={!isCopyButton ? buttonLink : undefined}
      >
        {cardContent.pricePromiseVoucher ? (
          <img src={whiteCopyPath} alt="White Copy Icon" className="white-copy-icon" />
        ) : (
          <img src={rightArrowIconPath} alt="Right Arrow Icon" className="right-arrow-icon" />
        )}
        {cardContent.buttonText}
      </Button>
    </div>
  );

  renderAmountToSave = (cardContent) => (
    (cardContent.amountToSave || cardContent.smartPassSumSavings || cardContent.pricePromiseSum) && (
      <div className="card-content__amount-to-save">
        <p>
          {(Number(cardContent.couponsToUse) !== 0 ?
            cardContent.amountToSave :
            (
              <>
                {cardContent.amountToSave}
                <strong className="smart-pass-info">*</strong>
              </>
            )) || (cardContent.smartPassSumSavings && (
            <>
                {cardContent.smartPassSumSavings}
                <strong className="smart-pass-info">†</strong>
            </>
          )) || cardContent.pricePromiseSum}
        </p>
      </div>
    )
  );

  render() {
    const { cardContent, buttonLink, smartPassType, rightArrowIcon, whiteCopy } = this.props;
    const rightArrowIconPath = images(`./${rightArrowIcon}`);
    const whiteCopyPath = whiteCopy ? images(`./${whiteCopy}`) : null;
    const isCopyButton = !!cardContent.pricePromiseVoucher;
    const mobileDescription = `${cardContent.description} ${cardContent.description2}`;

    return (
      <>
        {this.renderHeader(cardContent)}
        <div className={cardContent.className}>
          {cardContent.pricePromiseVoucher && <h3 className="card-content__voucher-title">{cardContent.title}</h3>}
          {this.renderDetails(cardContent, smartPassType)}
          {cardContent.className === 'card-content_no-subscription' && <h3 className="no-subscription-title">{cardContent.title}</h3>}

          {cardContent.description2 && cardContent.className !== 'card-content_no-voucher' && (
            <>
              <div className="card-content__description__mobile visible-mobile">
                {mobileDescription}
              </div>
              <p className="card-content__description hidden-mobile">
                {cardContent.description}
              </p>
              {this.renderAmountToSave(cardContent)}
              <p className="card-content__description2 hidden-mobile">
                {cardContent.description2}
              </p>
            </>
          )}
          {cardContent.className === 'card-content_no-voucher' &&
          <>
          <p className="card-content__description">
              {cardContent.description}
            </p>
          <p className="card-content__description2">
                {cardContent.description2}
            </p>
          </>
          }

          {(cardContent.amountToSave || cardContent.smartPassSumSavings) &&
            <>
              <p className="card-content__description">
                {cardContent.description}
              </p>
              {this.renderAmountToSave(cardContent)}
            </>
          }
          {this.renderActions(cardContent, whiteCopyPath, rightArrowIconPath, isCopyButton, buttonLink)}
        </div>
      </>
    );
  }
}

export default CardItemsSavingMoney;
